import { render } from "./RiddleGame.vue?vue&type=template&id=178271c0"
import script from "./RiddleGame.vue?vue&type=script&lang=js"
export * from "./RiddleGame.vue?vue&type=script&lang=js"

import "@/styles/RiddleGame.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__